export default __webpack_public_path__ + "static/media/Margaritas.37c4d624.jpg";